import { SupportFormInputField } from './SupportFormInputField';

export type EmailFieldProps = {
  isEnabled?: boolean;
};

export const EmailField = ({ isEnabled = true }: EmailFieldProps) => (
  <SupportFormInputField
    name="email"
    label="Email"
    helpText="Replies will be sent to this address."
    inputProps={{
      type: 'email',
      isRequired: true,
      isDisabled: !isEnabled,
    }}
  />
);
